// auth
export const SET_AUTH_MSG = 'SET_AUTH_MSG'
export const RESET_AUTH_MSG = 'RESET_AUTH_MSG'
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const CLEAR_USER = 'CLEAR_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_POINTS = 'UPDATE_USER_POINTS'
export const RESET_USER_ADDRESSES = 'RESET_USER_ADDRESSES'
export const FETCH_USER_ADDRESSES = 'FETCH_USER_ADDRESSES'
export const ADD_USER_ADDRESS = 'ADD_USER_ADDRESS'
export const UPDATE_USER_ADDRESS = 'UPDATE_USER_ADDRESS'
export const RESET_USER_CUSTOM_SETS = 'RESET_USER_CUSTOM_SETS'
export const FETCH_USER_CUSTOM_SETS = 'FETCH_USER_CUSTOM_SETS'
export const ADD_USER_CUSTOM_SET = 'ADD_USER_CUSTOM_SET'
export const UPDATE_USER_CUSTOM_SET = 'UPDATE_USER_CUSTOM_SET'
export const RESET_USER_RESERVATIONS = 'RESET_USER_RESERVATIONS'
export const FETCH_USER_RESERVATIONS = 'FETCH_USER_RESERVATIONS'
export const ADD_USER_RESERVATION = 'ADD_USER_RESERVATION'
export const SET_LOGIN_BY_MEMBER_TOKEN = 'SET_LOGIN_BY_MEMBER_TOKEN'
export const RESET_LOGIN_BY_MEMBER_TOKEN = 'RESET_LOGIN_BY_MEMBER_TOKEN'

// message
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'

// config
export const SET_CONFIG_MSG = 'SET_CONFIG_MSG'
export const RESET_CONFIG_MSG = 'RESET_CONFIG_MSG'
export const FETCH_CAT_GROUPS = 'FETCH_CAT_GROUPS'
export const FETCH_CATS = 'FETCH_CATS'
export const FETCH_OUTLETS = 'FETCH_OUTLETS'
export const FETCH_THEMES = 'FETCH_THEMES'
export const SET_GID = 'SET_GID'
export const SET_RID = 'SET_RID'
export const RESET_RES_DETAILS = 'RESET_RES_DETAILS'
export const SET_TB = 'SET_TB'
export const SET_BROWSER_ID = 'SET_BROWSER_ID'
export const SET_MODE = 'SET_MODE'
export const FETCH_CONFIG = 'FETCH_CONFIG'
export const SET_TRANSID = 'SET_TRANSID'
export const RESET_TRANSID = 'RESET_TRANSID'
export const SET_VERSION = 'SET_VERSION'
export const SET_STOREDVERSION = 'SET_STOREDVERSION'
export const SET_TBDATA = 'SET_TBDATA'
export const FETCH_TABLES = 'FETCH_TABLES'
export const RESET_TABLES = 'RESET_TABLES'
export const RESET_LANGUAGE = 'RESET_LANGUAGE'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const SET_MODE_SELECTED = 'SET_MODE_SELECTED'
export const RESET_MODE_SELECTED = 'RESET_MODE_SELECTED'
export const SET_MEMBER_TOKEN = 'SET_MEMBER_TOKEN'
export const RESET_MEMBER_TOKEN = 'RESET_MEMBER_TOKEN'
export const SET_VISIT_AT_TIMESTAMP = 'SET_VISIT_AT_TIMESTAMP'

// menu
export const RESET_MENU_DATA = 'RESET_MENU_DATA'
export const SET_MENU_MSG = 'SET_MENU_MSG'
export const RESET_MENU_MSG = 'RESET_MENU_MSG'
export const FETCH_MENU_CATS = 'FETCH_MENU_CATS'
export const FETCH_MENU_ITEMS = 'FETCH_MENU_ITEMS'
export const SET_MENU_ITEM_STATUS = 'SET_MENU_ITEM_STATUS'
export const RESET_MENU_ITEM_STATUS = 'RESET_MENU_ITEM_STATUS'
export const SET_MAIN_CAT = 'SET_MAIN_CAT'
export const SET_MENU_ITEM = 'SET_MENU_ITEM'
export const RESET_MENU_ITEM = 'RESET_MENU_ITEM'
export const SET_MENU_ITEM_QTY = 'SET_MENU_ITEM_QTY'
export const CHANGE_MENU_ITEM_QTY = 'CHANGE_MENU_ITEM_QTY'
export const CHANGE_MENU_ITEM_PRICE = 'CHANGE_MENU_ITEM_PRICE'
export const CHANGE_MENU_ITEM_STATUS = 'CHANGE_MENU_ITEM_STATUS'
export const SET_MENU_ITEM_SPECIALREQ = 'SET_MENU_ITEM_SPECIALREQ'
export const SET_MENU_ITEM_OPTIONS = 'SET_MENU_ITEM_OPTIONS'
export const SET_MENU_ITEM_TOPPINGS = 'SET_MENU_ITEM_TOPPINGS'
export const SET_MENU_ITEM_COURSE_ITEMS = 'SET_MENU_ITEM_COURSE_ITEMS'
export const SHOW_MENU_ITEM_DIALOG = 'SHOW_MENU_ITEM_DIALOG'
export const HIDE_MENU_ITEM_DIALOG = 'HIDE_MENU_ITEM_DIALOG'
export const SHOW_CAT_LIST_DIALOG = 'SHOW_CAT_LIST_DIALOG'
export const HIDE_CAT_LIST_DIALOG = 'HIDE_CAT_LIST_DIALOG'
export const FETCH_SUBMENU = 'FETCH_SUBMENU'
export const SET_SELECTED_PANEL = 'SET_PANEL'
export const RESET_SELECTED_PANEL = 'RESET_PANEL'

// cart
export const RESET_CART_DATA = 'RESET_CART_DATA'
export const SET_CART_MSG = 'SET_CART_MSG'
export const RESET_CART_MSG = 'RESET_CART_MSG'
export const FETCH_CART = 'FETCH_CART'
export const RESET_CART = 'RESET_CART'
export const ADD_CART_ITEM = 'ADD_CART_ITEM'
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const SHOW_CART_ITEM_DIALOG = 'SHOW_CART_ITEM_DIALOG'
export const HIDE_CART_ITEM_DIALOG = 'HIDE_CART_ITEM_DIALOG'
export const SET_PICKUP_DATE = 'SET_PICKUP_DATE'
export const RESET_PICKUP_DATE = 'RESET_PICKUP_DATE'
export const SET_PICKUP_TIME = 'SET_PICKUP_TIME'
export const RESET_PICKUP_TIME = 'RESET_PICKUP_TIME'
export const SET_DATES = 'SET_DATES'
export const RESET_DATES = 'RESET_DATES'
export const SET_TIMES = 'SET_TIMES'
export const RESET_TIMES = 'RESET_TIMES'
export const SET_REMARKS = 'SET_REMARKS'
export const RESET_REMARKS = 'RESET_REMARKS'
export const ADD_CART_VOUCHER = 'ADD_CART_VOUCHER'
export const REMOVE_CART_VOUCHER = 'REMOVE_CART_VOUCHER'
export const SET_DISCOUNT_INFO = 'SET_DISCOUNT_INFO'
export const RESET_DISCOUNT_INFO = 'RESET_DISCOUNT_INFO'
export const SET_GUEST_DETAILS = 'SET_GUEST_DETAILS'
export const RESET_GUEST_DETAILS = 'RESET_GUEST_DETAILS'

// order
export const RESET_ORDER_DATA = 'RESET_ORDER_DATA'
export const RESET_ACTIVE_ORDER_DATA = 'RESET_ACTIVE_ORDER_DATA'
export const SET_ORDER_MSG = 'SET_ORDER_MSG'
export const RESET_ORDER_MSG = 'RESET_ORDER_MSG'
export const CHECK_ORDER = 'CHECK_ORDER'
export const CHECK_SUBMIT_ORDER = 'CHECK_SUBMIT_ORDER'
export const CHECK_FINAL_ORDER = 'CHECK_FINAL_ORDER'
export const CONFIRM_ORDER = 'CONFIRM_ORDER'
export const UPDATE_ACTIVE_ORDER = 'UPDATE_ACTIVE_ORDER'
export const RESET_ORDER = 'RESET_ORDER'
export const FETCH_ORDERS = 'FETCH_ORDERS'
export const ADD_ORDER = 'ADD_ORDER'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const CANCEL_ORDER = 'CANCEL_ORDER'
export const SAVE_QUEUE = 'SAVE_QUEUE'
export const SET_QUEUES = 'SET_QUEUES'
export const RESET_QUEUES = 'RESET_QUEUES'
export const SAVE_POINTS = 'SAVE_POINTS'
export const SET_OPEN_TABLES = 'SET_OPEN_TABLES'
export const RESET_OPEN_TABLES = 'RESET_OPEN_TABLES'
export const SET_PAYMENT_MODE = 'SET_PAYMENT_MODE'
export const RESET_PAYMENT_MODE = 'RESET_PAYMENT_MODE'
export const ENABLE_USE_POINTS = 'ENABLE_USE_POINTS'
export const DISABLE_USE_POINTS = 'DISABLE_USE_POINTS'
export const ENABLE_USE_VOUCHERS = 'ENABLE_USE_VOUCHERS'
export const DISABLE_USE_VOUCHERS = 'DISABLE_USE_VOUCHERS'
export const SET_BILL = 'SET_BILL'
export const UPDATE_ACTIVE_BILL = 'UPDATE_ACTIVE_BILL'
export const RESET_BILL = 'RESET_BILL'

// member
export const RESET_MEMBER_DATA = 'RESET_MEMBER_DATA'
export const SET_MEMBER_MSG = 'SET_MEMBER_MSG'
export const RESET_MEMBER_MSG = 'RESET_MEMBER_MSG'
export const FETCH_MEMBER_CATS = 'FETCH_MEMBER_CATS'
export const FETCH_MEMBER_ITEMS = 'FETCH_MEMBER_ITEMS'
export const FETCH_POINTS = 'FETCH_POINTS'
export const FETCH_PROFILE = 'FETCH_PROFILE'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const SET_HAS_ANY_MEMBER = 'SET_HAS_ANY_MEMBER'
export const FETCH_INBOX = 'FETCH_INBOX'
export const FETCH_MEMBERSHIP = 'FETCH_MEMBERSHIP'
export const FETCH_MEMBERSHIP_CONFIG = 'FETCH_MEMBERSHIP_CONFIG'
export const ADD_MEMBERSHIP_ITEM = 'ADD_MEMBERSHIP_ITEM'
export const RESET_MEMBERSHIP_ITEM = 'RESET_MEMBERSHIP_ITEM'
export const CHECK_FINAL_MEMBERSHIP_ORDER = 'CHECK_FINAL_MEMBERSHIP_ORDER'

// voucher
export const RESET_VOUCHER_DATA = 'RESET_VOUCHER_DATA'
export const RESET_VOUCHERS = 'RESET_VOUCHERS'
export const SET_VOUCHER_MSG = 'SET_VOUCHER_MSG'
export const RESET_VOUCHER_MSG = 'RESET_VOUCHER_MSG'
export const FETCH_ALL_VOUCHERS = 'FETCH_ALL_VOUCHERS'
export const FETCH_VOUCHERS = 'FETCH_VOUCHERS'
export const SHOW_PROMOTION_DIALOG = 'SHOW_PROMOTION_DIALOG'
export const HIDE_PROMOTION_DIALOG = 'HIDE_PROMOTION_DIALOG'
export const SHOW_VOUCHER_ITEM_DIALOG = 'SHOW_VOUCHER_ITEM_DIALOG'
export const HIDE_VOUCHER_ITEM_DIALOG = 'HIDE_VOUCHER_ITEM_DIALOG'
export const SET_PROMOTION_ITEM = 'SET_PROMOTION_ITEM'
export const RESET_PROMOTION_ITEM = 'RESET_PROMOTION_ITEM'
export const SET_PROMOTION_VOUCHER = 'SET_PROMOTION_VOUCHER'
export const RESET_PROMOTION_VOUCHER = 'RESET_PROMOTION_VOUCHER'
export const REMOVE_DISCOUNT_CART_VOUCHER = 'REMOVE_DISCOUNT_CART_VOUCHER'

// dialog
export const SHOW_SETTINGDIALOG = 'SHOW_SETTINGDIALOG'
export const HIDE_SETTINGDIALOG = 'HIDE_SETTINGDIALOG'

// receipt
export const RESET_RECEIPT_DATA = 'RESET_RECEIPT_DATA'
export const SET_RECEIPT_MSG = 'SET_RECEIPT_MSG'
export const RESET_RECEIPT_MSG = 'RESET_RECEIPT_MSG'
export const FETCH_RECEIPTS = 'FETCH_RECEIPTS'
export const ADD_RECEIPT = 'ADD_RECEIPT'

// delivery
export const RESET_DELIVERY_DATA = 'RESET_DELIVERY_DATA'
export const SET_DELIVERY_MSG = 'SET_DELIVERY_MSG'
export const RESET_DELIVERY_MSG = 'RESET_DELIVERY_MSG'
export const RESET_ADDRESS = 'RESET_ADDRESS'
export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_ADDRESS_REMARKS = 'SET_ADDRESS_REMARKS'
export const SET_ADDRESS_CUTLERY = 'SET_ADDRESS_CUTLERY'
export const SET_DELIVERY_INFO = 'SET_DELIVERY_INFO'
export const RESET_DELIVERY_INFO = 'RESET_DELIVERY_INFO'
export const SET_DELIVERY_PLU = 'SET_DELIVERY_PLU'
export const RESET_DELIVERY_PLU = 'RESET_DELIVERY_PLU'

// area
export const FETCH_AREAS = 'FETCH_AREAS'
export const SET_SELECTED_AREA = 'SET_SELECTED_AREA'
export const RESET_SELECTED_AREA = 'RESET_SELECTED_AREA'
export const SET_SELECTED_AREA_MODE = 'SET_SELECTED_AREA_MODE'
export const RESET_SELECTED_AREA_MODE = 'RESET_SELECTED_AREA'
export const SHOW_POSTAL_CODE_DIALOG = 'SHOW_POSTAL_CODE_DIALOG'
export const HIDE_POSTAL_CODE_DIALOG = 'HIDE_POSTAL_CODE_DIALOG'
export const FETCH_RESTAURANT_DISTANCE = 'FETCH_RESTAURANT_DISTANCE'
export const CLEAR_RESTAURANT_DISTANCE = 'CLEAR_RESTAURANT_DISTANCE'
export const SET_POSTAL_CODE = 'SET_POSTAL_CODE'
export const RESET_POSTAL_CODE = 'RESET_POSTAL_CODE'
export const SET_NEAREST_OUTLET = 'SET_NEAREST_OUTLET'
export const RESET_NEAREST_OUTLET = 'RESET_NEAREST_OUTLET'
export const RESET_AREA_MSG = 'SET_AREA_MSG'
export const RESET_DELIVERABLE = 'RESET_DELIVERABLE'
export const RESET_STATE = 'RESET_STATE'
export const SET_IS_EXPO = 'SET_IS_EXPO'
export const RESET_IS_EXPO = 'RESET_IS_EXPO'
export const SET_AREA_LIST_MODE = 'SET_AREA_LIST_MODE'
export const RESET_AREA_LIST_MODE = 'RESET_AREA_LIST_MODE'

// promo
export const RESET_PROMO_DATA = 'RESET_PROMO_DATA'
export const SET_PROMO_MSG = 'SET_PROMO_MSG'
export const RESET_PROMO_MSG = 'RESET_PROMO_MSG'
export const SET_PROMO_ITEMS = 'SET_PROMO_ITEMS'
export const RESET_PROMO_ITEMS = 'RESET_PROMO_ITEMS'
export const SET_ACTIVE_PROMO = 'SET_ACTIVE_PROMO'
export const RESET_ACTIVE_PROMO = 'RESET_ACTIVE_PROMO'

// banner
export const RESET_BANNER_DATA = 'RESET_BANNER_DATA'
export const SET_BANNER_MSG = 'SET_BANNER_MSG'
export const RESET_BANNER_MSG = 'RESET_BANNER_MSG'
export const FETCH_BANNERS = 'FETCH_BANNERS'
export const RESET_BANNERS = 'RESET_BANNERS'

export const SET_DINE_MODE_DINE_IN_TIMES = 'SET_DINE_MODE_DINE_IN_TIMESLOTS'

// takeaway
export const RESET_TAKEAWAY_CONTACT = 'RESET_TAKEAWAY_CONTACT'
export const SET_TAKEAWAY_CONTACT = 'SET_TAKEAWAY_CONTACT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js